import React from 'react';
import ChunkForm from './ChunkForm';

interface Document {
  id: number;
  name: string;
}

interface ChunkNewProps {
  document: Document;
  errors: Record<string, string[]>;
}

export default function ChunkNew({ document, errors = {} }: ChunkNewProps) {
  const emptyChunk = {
    page_number: undefined,
    citation: '',
    content: '',
    embed: '',
    metadata: undefined,
  };

  return (
    <ChunkForm 
      document={document}
      chunk={emptyChunk} 
      isEdit={false} 
      errors={errors}
    />
  );
}